module.exports = "/_next/static/images/OgIndustryStartups-bf9283ebb30171d1506502b34f2922e2.png";